import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { Box } from '@mui/material'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function SuggestionForm({ updateReports, startIcon, open, setOpen }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  let w_tpriority = localStorage.getItem('w-tpriority')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [userPriority, setUserPriority] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { handleSubmit, reset } = useForm({})

  useEffect(() => {
    fetchUserPriority()
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)

    reset()
  }

  const onSubmit = async (data) => {
    setIsSubmitting(true)
    try {
      const payload = {
        userPriority: userPriority,
      }

      const response = await makePostRequest(urls.UpdateSuggest, payload, {}, true)
      if (response.status === 200) {
        // Generate initial suggestions after priority update
        await makePostRequest('/api/general/task-suggestions/generate/', {}, {}, true)
        
        // Refresh the suggestions list
        await updateReports()
        
        handleClose()
        
        if (w_tpriority) {
          await makePostRequest(
            '/api/app/user-wizard/',
            { step: w_tpriority, completed: true, skip: true },
            {},
            true,
          )

          dispatch(setUserWizardDone({ step: w_tpriority, completed: true, skip: true }))
          localStorage.removeItem('w-tpriority')
          navigate('/')
        }
      }
    } catch (error) {
      console.error('Error updating priorities:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  const fetchUserPriority = async () => {
    const url = urls.getAllTimeCatgory
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setUserPriority(
        data.map((e) => {
          return { id: e.id, text: e.name }
        }),
      )
    }
  }
  const handleDrop = (droppedItem) => {
    if (!droppedItem.destination) return
    var updatedList = [...userPriority]

    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1)

    updatedList.splice(droppedItem.destination.index, 0, reorderedItem)

    setUserPriority(updatedList)
  }

  return (
    <>
      <Box sx={{ cursor: 'pointer' }} onClick={handleClickOpen}>
        {startIcon}
      </Box>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose} sx={{ bgcolor: '#001b42' }}>
        <DialogTitle sx={{ color: '#383838 !important' }}>{t('syntheseTemps.prioritiesDialogTitle')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <DragDropContext onDragEnd={handleDrop}>
              <Droppable droppableId="list-container">
                {(provided) => (
                  <Box {...provided.droppableProps} ref={provided.innerRef}>
                    {userPriority.map((item, index) => (
                      <Draggable key={item.id} draggableId={'dd-' + item.id} index={index}>
                        {(provided) => (
                          <Box
                            mb={2}
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                          >
                            {index + 1}
                            {'. '} {item.text}
                          </Box>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </DialogContent>
          <DialogActions>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? t('syntheseTemps.validating') : t('syntheseTemps.validate')}
            </Button>
            <Button
              disabled={isSubmitting}
              onClick={() => {
                handleClose()
                if (w_tpriority) {
                  localStorage.removeItem('w-tpriority')
                  navigate('/')
                }
              }}
            >
              {t('syntheseTemps.cancel')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
